import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Segment, Dimmer, Loader, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class SOQModal extends Component {
  constructor(props) {
    super(props);
    this.handleAccept = this.handleAccept.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {partCode, showModal} = this.props;
    const isOpen = !prevProps.showModal && showModal;

    if (isOpen && partCode && prevProps.partCode !== partCode) {
      this.props.getPartSOQResume(partCode);
    }
  }

  handleAccept() {
    this.props.hideOrderPartSOQResume();
  }

  renderContent() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Modal.Content>
          <Segment>
            <Dimmer active>
              <Loader>
                Obteniendo el cálculo del SOQ...
              </Loader>
            </Dimmer>
          </Segment>
        </Modal.Content>
      );
    }

    const {
      salesMIP, salesMAD, leadTime, orderCycle, salesSafetyStockMAD, ordersSafetyStockMAD,
      safetyStockLeadTime, ordersMIP, ordersMAD, backOrder, onHand, onOrder, salesSOQ, ordersSOQ,
    } = this.props.resume || {};

    return (
      <Modal.Content>
        <div>
          <strong>MIP = MAD * (LT + OC + SSMAD + SSLT)</strong>
          <br />
          <strong>SOQ =  MIP - (OO + OH) + BO</strong>
        </div>
        <div>
          <strong>Ventas:</strong>
          <br />
          MIP = {salesMAD} * ({leadTime} + {orderCycle} + {salesSafetyStockMAD} + {safetyStockLeadTime})
          <br />
          SOQ = {salesMIP} - ({onOrder} + {onHand}) + {backOrder} = {salesSOQ}
          <br />
          <strong>Pedidos:</strong>
          <br />
          MIP = {ordersMAD} * ({leadTime} + {orderCycle} + {ordersSafetyStockMAD} + {safetyStockLeadTime})
          <br />
          SOQ = {ordersMIP} - ({onOrder} + {onHand}) + {backOrder} = {ordersSOQ}
        </div>
      </Modal.Content>
    );
  }

  render() {
    const {showModal} = this.props;

    return (
      <Modal
        size='tiny'
        trigger={<div />}
        className='SOQ-modal'
        open={showModal}
      >
        <Modal.Header>Fórmula SOQ</Modal.Header>
        {this.renderContent()}
        <Modal.Actions>
          <Button primary onClick={this.handleAccept}>ACEPTAR</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.providerStockOrders.loadingSOQResume,
    'resume': state.providerStockOrders.SOQResume,
    'showModal': state.providerStockOrders.showSOQModal,
    'partCode': state.providerStockOrders.partCodeForStock,
  };
};

const {
  getPartSOQResume,
  hideOrderPartSOQResume,
} = Actions;

export default connect(mapStateToProps, {
  getPartSOQResume,
  hideOrderPartSOQResume,
})(SOQModal);
